import React from "react";
import { motion } from "framer-motion";
import "../styles/AnimatedStatsPage.css"; // Custom styles
import {Box} from '@mui/material';

const stats = [
  { icon: "🌍", number: 500, label: "Awesome Tour" },
  { icon: "🗺️", number: 300, label: "New Destinations" },
  { icon: "🏅", number: 7, label: "Year Experience" },
  { icon: "⛰️", number: 270, label: "Best Tour" },
];

const AnimatedStatsPage = () => {
  return (
    < Box sx={{
      py: { xs: 2, sm: 6, md: 10, lg: 10 }
  }}>
    <div className="page">
      <div className="overlay" />
      <div className="header">
        <h1>
          Get 20% OFF Your <br />
          First <span className="highlight">TRIP!</span>
        </h1>
        <p>
          Don’t Wanna Miss Somethings? Subscribe Right Now & Get The Special
          Discount & Monthly Newsletter.
        </p>
      </div>
      <div className="stats">
        {stats.map((item, index) => (
         <motion.div
         key={index}
         className="card"
         initial={{ opacity: 0, y: 100 }}
         whileInView={{ opacity: 1, y: 0 }}
         viewport={{ once: true, amount: 0.2 }}
         transition={{ delay: 0.2 * index, duration: 0.6 }}
       >
         <div className="icon">{item.icon}</div>
         <div className="number">{item.number}</div>
         <div className="label">{item.label}</div>
       </motion.div>
       
        ))}
      </div>
    </div>
    </Box>
  );
};

export default AnimatedStatsPage;
